import { styled, Typography } from '@mui/material';
export const tagsFieldStyles = (disabled: boolean) => ({
  height: 'auto',
  opacity: disabled ? '0.5' : 1,
  '.MuiSelect-select.MuiSelect-select': {
    height: disabled ? '56px' : 'auto',
  },
});

export const tagsFieldMobileStyles = (disabled: boolean) => ({
  height: 'auto',
  minHeight: '60px',
  opacity: disabled ? '0.5' : 1,
  '.MuiSelect-select.MuiSelect-select': {
    height: 'auto',
  },
});

export const LabelW = styled('label')`
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  width: 56px;
  max-width: 56px;
  white-space: nowrap;
  margin-left: 10px;
  color: ${({ theme }) => theme.palette.primary.main};

  @media (max-width: 1023px) {
    width: 48px;
  }
`;

export const InputW = styled('input')`
  width: 20px;
  height: 20px;
  accent-color: ${({ theme }) => theme.palette.info.main};
`;

export const CheckboxSection = styled('div')`
  display: flex;
  flex-direction: row;
  gap: 64px;
`;

export const CheckboxContainer = styled('div')`
  display: flex;
  align-items: center;
  padding-top: 10px;
`;

export const LabelTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '14px',
  lineHeight: '24px',
  color: theme.palette.primary.p080,
  marginBottom: '16px',
  marginLeft: '10px',
  [theme.breakpoints.down('desktop')]: {
    marginBottom: '8px',
  },
}));

export const CheckboxWrapper = styled('div')`
  display: flex;
  align-items: center;
`;

export const SpinnerW = styled('div')`
  width: 48px;
  height: 48px;
  overflow: hidden;
  border-radius: 10px;
  margin-right: 16px;
  cursor: not-allowed;
  background-color: ${({ theme }) => theme.palette.info.p030};
  position: relative;
`;

export const GroupWrapper = styled('div')`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 16px;
  font-weight: bold;
  font-size: 18px;
`;

export const AccordinWrapper = styled('div')`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-weight: bold;
  font-size: 16px;
`;
